package com.shadowings.gero.presentation.component.avatars

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.presentation.screen.characters.CharacterConsts
import com.shadowings.gero.presentation.screen.characters.backgroundOptions
import com.shadowings.gero.presentation.screen.characters.earringsOptions
import com.shadowings.gero.presentation.screen.characters.eyesOptions
import com.shadowings.gero.presentation.screen.characters.hairOptions
import com.shadowings.gero.presentation.screen.characters.hatBarOptions
import com.shadowings.gero.presentation.screen.characters.hatOptions
import com.shadowings.gero.presentation.screen.characters.mouthOptions
import com.shadowings.gero.presentation.screen.characters.shirtOptions
import com.shadowings.gero.presentation.screen.characters.skinOptions
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.ui.neutralBlack
import com.shadowings.gero.presentation.ui.neutralCyan
import com.shadowings.gero.presentation.ui.neutralRed
import com.shadowings.gero.presentation.ui.neutralWhite
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.alyn_hat_egypt_back
import gero.composeapp.generated.resources.alyn_hat_egypt_back_accent
import gero.composeapp.generated.resources.alyn_hat_egypt_left_accent
import gero.composeapp.generated.resources.alyn_hat_egypt_top
import gero.composeapp.generated.resources.alyn_hat_egypt_top_accent
import gero.composeapp.generated.resources.alyn_hat_egypt_top_left
import gero.composeapp.generated.resources.alyn_layer_0_orecchio
import gero.composeapp.generated.resources.alyn_layer_10_cry_eyebrows
import gero.composeapp.generated.resources.alyn_layer_10_cry_eyes_back
import gero.composeapp.generated.resources.alyn_layer_10_cry_eyes_front
import gero.composeapp.generated.resources.alyn_layer_10_cry_mouth
import gero.composeapp.generated.resources.alyn_layer_10_cry_tears
import gero.composeapp.generated.resources.alyn_layer_10_happy_eyebrows
import gero.composeapp.generated.resources.alyn_layer_10_happy_mouth
import gero.composeapp.generated.resources.alyn_layer_10_idle_eyes_back
import gero.composeapp.generated.resources.alyn_layer_10_idle_eyes_front
import gero.composeapp.generated.resources.alyn_layer_10_idle_mouth
import gero.composeapp.generated.resources.alyn_layer_10_perfect_cheecks
import gero.composeapp.generated.resources.alyn_layer_10_perfect_eyebrows
import gero.composeapp.generated.resources.alyn_layer_10_perfect_teeth
import gero.composeapp.generated.resources.alyn_layer_10_perfect_teeth_over
import gero.composeapp.generated.resources.alyn_layer_10_sad_eyebrows
import gero.composeapp.generated.resources.alyn_layer_10_sad_eyes_back
import gero.composeapp.generated.resources.alyn_layer_10_sad_eyes_front
import gero.composeapp.generated.resources.alyn_layer_10_sad_mouth
import gero.composeapp.generated.resources.alyn_layer_10_serious_eyebrows
import gero.composeapp.generated.resources.alyn_layer_10_serious_eyes_back
import gero.composeapp.generated.resources.alyn_layer_10_serious_eyes_front
import gero.composeapp.generated.resources.alyn_layer_10_serious_mouth
import gero.composeapp.generated.resources.alyn_layer_10_surprised_eyebrows
import gero.composeapp.generated.resources.alyn_layer_10_surprised_eyes_back
import gero.composeapp.generated.resources.alyn_layer_10_surprised_eyes_front
import gero.composeapp.generated.resources.alyn_layer_10_surprised_mouth
import gero.composeapp.generated.resources.alyn_layer_10_surprised_tongue
import gero.composeapp.generated.resources.alyn_layer_1_orecchino
import gero.composeapp.generated.resources.alyn_layer_2_maglietta
import gero.composeapp.generated.resources.alyn_layer_3_orecchio
import gero.composeapp.generated.resources.alyn_layer_4_barra_cappello
import gero.composeapp.generated.resources.alyn_layer_5_cappello
import gero.composeapp.generated.resources.alyn_layer_5_cappello_accento_basco
import gero.composeapp.generated.resources.alyn_layer_5_cappello_basco
import gero.composeapp.generated.resources.alyn_layer_5_cappello_viking
import gero.composeapp.generated.resources.alyn_layer_5_cappello_viking_accent
import gero.composeapp.generated.resources.alyn_layer_5_cappello_viking_back
import gero.composeapp.generated.resources.alyn_layer_5_cappello_viking_horn
import gero.composeapp.generated.resources.alyn_layer_5b_cappello
import gero.composeapp.generated.resources.alyn_layer_6_capelli_front
import gero.composeapp.generated.resources.alyn_layer_7_faccia
import gero.composeapp.generated.resources.alyn_layer_7b_collo
import gero.composeapp.generated.resources.alyn_layer_7b_faccia_ombra
import gero.composeapp.generated.resources.alyn_layer_7b_naso
import gero.composeapp.generated.resources.alyn_layer_8_capelli_back
import gero.composeapp.generated.resources.alyn_layer_8b_capelli_back
import gero.composeapp.generated.resources.alyn_layer_9_cappello_back
import org.jetbrains.compose.resources.DrawableResource


fun Color.darken(factor: Float = 0.75f): Color {
    return Color(
        red = (red * factor).coerceIn(0f, 1f),
        green = (green * factor).coerceIn(0f, 1f),
        blue = (blue * factor).coerceIn(0f, 1f),
        alpha = alpha
    )
}

fun Color.lighten(factor: Float = 0.75f): Color {
    return Color(
        red = (red / factor).coerceIn(0f, 1f),
        green = (green / factor).coerceIn(0f, 1f),
        blue = (blue / factor).coerceIn(0f, 1f),
        alpha = alpha
    )
}

fun Color.reddish(factor: Float = 0.75f): Color {
    return Color(
        red = (red).coerceIn(0f, 1f),
        green = (green * factor).coerceIn(0f, 1f),
        blue = (blue * factor).coerceIn(0f, 1f),
        alpha = alpha
    )
}

@Preview
@Composable
fun AlynAvatarPreview() {

    AppTheme {
        FlowRow {
            Faces.entries.forEach { face ->
                Column {
                    AlynAvatar(
                        face = face
                    )
                }
            }
        }
    }
}


@Composable
fun AlynAvatar(
    userData: UserData = UserData(),
    face: Faces = Faces.Serious,
    modifier: Modifier = Modifier.size(256.dp),
    withBackground: Boolean = true
) {
    val bgColorIndex =
        (userData.alynColors[CharacterConsts.BG_KEY] ?: 0).coerceIn(0, backgroundOptions.size - 1)
    val skinColorIndex = (userData.alynColors["skin"] ?: 0).coerceIn(0, skinOptions.size - 1)
    val hairColorIndex = (userData.alynColors["hair"] ?: 7).coerceIn(0, hairOptions.size - 1)
    val earringsIndex = (userData.alynColors["earrings"] ?: 0).coerceIn(0, earringsOptions.size - 1)
    val shirtColorIndex = (userData.alynColors["shirt"] ?: 7).coerceIn(0, shirtOptions.size - 1)
    val hatBarColorIndex = (userData.alynColors["hatBar"] ?: 3).coerceIn(0, hatBarOptions.size - 1)
    val hatColorIndex = (userData.alynColors["hat"] ?: 0).coerceIn(0, hatOptions.size - 1)
    val eyesColorIndex = (userData.alynColors["eyes"] ?: 1).coerceIn(0, eyesOptions.size - 1)
    val mouthColorIndex = (userData.alynColors["mouth"] ?: 0).coerceIn(0, mouthOptions.size - 1)
    val hatIndex = (userData.alynColors[CharacterConsts.HAT_TYPE_KEY] ?: 0).coerceIn(0, 3)

    fun getHatBack(): List<Pair<DrawableResource, Color>> {
        return when (hatIndex) {
            0 -> listOf(Res.drawable.alyn_layer_9_cappello_back to hatOptions[hatColorIndex].darken())
            1 -> listOf()
            2 -> listOf(Res.drawable.alyn_layer_5_cappello_viking_back to Color.White.darken(0.9f))
            3 -> listOf(
                Res.drawable.alyn_hat_egypt_back to hatOptions[hatColorIndex],
                Res.drawable.alyn_hat_egypt_back_accent to hatBarOptions[hatBarColorIndex]
            )

            else -> listOf()
        }
    }

    fun getHatShadow(): List<Pair<DrawableResource, Color>> {
        return when (hatIndex) {
            0 -> listOf(Res.drawable.alyn_layer_5b_cappello to neutralBlack)
            else -> listOf()
        }
    }

    fun getHat(): List<Pair<DrawableResource, Color>> {
        return when (hatIndex) {
            0 -> listOf(Res.drawable.alyn_layer_5_cappello to hatOptions[hatColorIndex])
            1 -> listOf(Res.drawable.alyn_layer_5_cappello_basco to hatOptions[hatColorIndex])
            2 -> listOf(Res.drawable.alyn_layer_5_cappello_viking to hatOptions[hatColorIndex])
            3 -> listOf(
                Res.drawable.alyn_hat_egypt_top_accent to hatBarOptions[hatBarColorIndex],
                Res.drawable.alyn_hat_egypt_top to hatOptions[hatColorIndex],
            )

            else -> listOf()
        }
    }

    fun getTopHat(): List<Pair<DrawableResource, Color>> {
        return when (hatIndex) {
            3 -> listOf(
                Res.drawable.alyn_hat_egypt_top_left to hatOptions[hatColorIndex],
                Res.drawable.alyn_hat_egypt_left_accent to hatBarOptions[hatBarColorIndex]
            )

            else -> listOf()
        }
    }

    fun getHatAccent(): List<Pair<DrawableResource, Color>> {
        return when (hatIndex) {
            0 -> listOf(Res.drawable.alyn_layer_4_barra_cappello to hatBarOptions[hatBarColorIndex])
            1 -> listOf(Res.drawable.alyn_layer_5_cappello_accento_basco to hatBarOptions[hatBarColorIndex])
            2 -> listOf(
                Res.drawable.alyn_layer_5_cappello_viking_accent to hatBarOptions[hatBarColorIndex],
                Res.drawable.alyn_layer_5_cappello_viking_horn to Color.White.darken(0.9f)
            )

            else -> listOf()
        }
    }

    val pairs: List<Pair<DrawableResource, Color>> =
        getHatBack() +
                listOf(
                    Res.drawable.alyn_layer_8b_capelli_back to hairOptions[hairColorIndex].darken(),
                    Res.drawable.alyn_layer_8_capelli_back to hairOptions[hairColorIndex],
                    Res.drawable.alyn_layer_7b_faccia_ombra to neutralBlack,
                    Res.drawable.alyn_layer_7b_collo to skinOptions[skinColorIndex],
                    Res.drawable.alyn_layer_7_faccia to skinOptions[skinColorIndex],
                    Res.drawable.alyn_layer_7b_naso to skinOptions[skinColorIndex].reddish(0.9f),
                    Res.drawable.alyn_layer_6_capelli_front to hairOptions[hairColorIndex]
                ) +
                getHatShadow() + getHat() + getHatAccent() + listOf(
            Res.drawable.alyn_layer_3_orecchio to skinOptions[skinColorIndex],
            Res.drawable.alyn_layer_2_maglietta to shirtOptions[shirtColorIndex],
            Res.drawable.alyn_layer_1_orecchino to earringsOptions[earringsIndex],
            Res.drawable.alyn_layer_0_orecchio to skinOptions[skinColorIndex],
        ) + getTopHat()
    val expression = when (face) {
        Faces.Surprised -> {
            listOf(
                Res.drawable.alyn_layer_10_surprised_eyes_back to neutralWhite,
                Res.drawable.alyn_layer_10_surprised_eyes_front to eyesOptions[eyesColorIndex],
                Res.drawable.alyn_layer_10_surprised_eyebrows to hairOptions[hairColorIndex].darken(),
                Res.drawable.alyn_layer_10_surprised_mouth to mouthOptions[mouthColorIndex],
                Res.drawable.alyn_layer_10_surprised_tongue to mouthOptions[mouthColorIndex].reddish(),
            )
        }

        Faces.Happy -> {
            listOf(
                Res.drawable.alyn_layer_10_happy_eyebrows to hairOptions[hairColorIndex].darken(),
                Res.drawable.alyn_layer_10_happy_mouth to neutralWhite
            )
        }

        Faces.Perfect -> {
            listOf(
                Res.drawable.alyn_layer_10_perfect_teeth to neutralWhite,
                Res.drawable.alyn_layer_10_perfect_teeth_over to neutralWhite.darken(),
                Res.drawable.alyn_layer_10_perfect_cheecks to neutralRed.copy(alpha = 0.15f),
                Res.drawable.alyn_layer_10_perfect_eyebrows to hairOptions[hairColorIndex].darken(),
            )
        }

        Faces.Cry -> {
            listOf(
                Res.drawable.alyn_layer_10_cry_mouth to mouthOptions[mouthColorIndex],
                Res.drawable.alyn_layer_10_cry_eyes_back to neutralWhite,
                Res.drawable.alyn_layer_10_cry_eyes_front to eyesOptions[eyesColorIndex],
                Res.drawable.alyn_layer_10_cry_tears to neutralCyan.darken(0.8f),
                Res.drawable.alyn_layer_10_cry_eyebrows to hairOptions[hairColorIndex].darken(),
            )
        }

        Faces.Sad -> {
            listOf(
                Res.drawable.alyn_layer_10_sad_mouth to mouthOptions[mouthColorIndex],
                Res.drawable.alyn_layer_10_sad_eyes_back to neutralWhite,
                Res.drawable.alyn_layer_10_sad_eyes_front to eyesOptions[eyesColorIndex],
                Res.drawable.alyn_layer_10_sad_eyebrows to hairOptions[hairColorIndex].darken(),
            )
        }

        Faces.Serious -> {
            listOf(
                Res.drawable.alyn_layer_10_serious_mouth to mouthOptions[mouthColorIndex],
                Res.drawable.alyn_layer_10_serious_eyes_back to neutralWhite,
                Res.drawable.alyn_layer_10_serious_eyes_front to eyesOptions[eyesColorIndex],
                Res.drawable.alyn_layer_10_serious_eyebrows to hairOptions[hairColorIndex].darken(),
            )
        }

        else -> {
            listOf(
                Res.drawable.alyn_layer_10_idle_mouth to mouthOptions[mouthColorIndex],
                Res.drawable.alyn_layer_10_idle_eyes_back to neutralWhite,
                Res.drawable.alyn_layer_10_idle_eyes_front to eyesOptions[eyesColorIndex],
            )
        }
    }

    BuildAvatar(withBackground, bgColorIndex, pairs, expression, modifier, face)

}
